function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { chain, find, split } from 'lodash';
export var BusquedaCV = /*#__PURE__*/function () {
  function BusquedaCV() {
    _classCallCheck(this, BusquedaCV);
    _defineProperty(this, "condiciones", []);
    _defineProperty(this, "vacio", true);
    _defineProperty(this, "estado", false);
    // activo búsqueda por estado
    _defineProperty(this, "fechas", false);
    _defineProperty(this, "maxcondiciones", -1);
  }
  return _createClass(BusquedaCV, [{
    key: "generaFiltros",
    value: function generaFiltros() {
      return {
        idform: this.opt.item.idf,
        w: this._generaWhere()
      };
    }
  }, {
    key: "_generaWhere",
    value: function _generaWhere() {
      return chain(this.condiciones).filter(function (c) {
        return c.valido();
      }).map(function (c) {
        return c.generaWhere();
      }).value();
    }
  }, {
    key: "setMaxCondiciones",
    value: function setMaxCondiciones(max) {
      this.maxcondiciones = max;
    }
  }, {
    key: "nuevaCondicionPregunta",
    value: function nuevaCondicionPregunta() {
      var c = new Condicion('PREGUNTA', this);
      this.condiciones.push(c);
      this.vacio = false;
      return c;
    }
  }, {
    key: "nuevaCondicionEstado",
    value: function nuevaCondicionEstado() {
      this.condiciones.push(new Condicion('ESTADO', this));
    }
  }, {
    key: "nuevaCondicionFechas",
    value: function nuevaCondicionFechas() {
      this.condiciones.push(new Condicion('FECHAS', this));
    }
  }, {
    key: "resetCondiciones",
    value: function resetCondiciones() {
      this.condiciones = [];
    }
  }, {
    key: "selMenu",
    value: function selMenu(menu) {
      this.menu = menu;
      this.idform = menu.idf;
      this.vacio = !this.menu;
    }
  }, {
    key: "selFormId",
    value: function selFormId(idform) {
      this.idform = idform;
      this.menu = null;
      this.vacio = !idform;
    }
  }, {
    key: "quitarCondicion",
    value: function quitarCondicion(idx) {
      this.condiciones.splice(idx, 1);
    }
  }]);
}();
export var Condicion = /*#__PURE__*/function () {
  // selecciones

  function Condicion(tipo, busqueda) {
    _classCallCheck(this, Condicion);
    _defineProperty(this, "sel", []);
    this.tipo = tipo;
    this.busqueda = busqueda;
  }
  return _createClass(Condicion, [{
    key: "generaWhere",
    value: function generaWhere() {
      var where = {
        tipocondicion: this.tipo,
        idq: null,
        cond_bool: null,
        cond_fin: null,
        cond_ini: null,
        cond_max: null,
        cond_min: null,
        cond_opt: null,
        cond_txt: null,
        incluir: true,
        cv_estado: null,
        cv_ini: null,
        cv_fin: null
      };
      switch (this.tipo) {
        case 'PREGUNTA':
          this.completaWherePreg(where);
          break;
        case 'FECHAS':
          this.completaWhereFechas(where);
          break;
        case 'ESTADO':
          this.completaWhereEstado(where);
          break;
      }
      return where;
    }
  }, {
    key: "completaWhereFechas",
    value: function completaWhereFechas(where) {
      where.cv_ini = this.model1 && new Date(this.model1);
      where.cv_fin = this.model2 && new Date(this.model2);
    }
  }, {
    key: "completaWhereEstado",
    value: function completaWhereEstado(where) {
      where.cv_estado = this.model1;
    }
  }, {
    key: "completaWherePreg",
    value: function completaWherePreg(where) {
      where.idq = this.pregform.q.idquest;
      switch (this.pregform.t) {
        case 'SINO':
          where.cond_bool = this.model1;
          break;
        case 'TXT':
          where.cond_txt = this.model1;
          break;
        case 'SEL':
          where.cond_opt = chain(this.sel).filter(function (s) {
            return !!s;
          }).value(); // no considerar las null
          break;
        case 'RANGO':
          where.cond_min = this.model1;
          where.cond_max = this.model2;
          break;
        case 'PERIODO':
          where.cond_ini = this.model1 && new Date(this.model1);
          where.cond_fin = this.model2 && new Date(this.model2);
          break;
        default:
      }
    }
  }, {
    key: "seleccionaPreg",
    value: function seleccionaPreg(idq) {
      // buscar la pregunta en la lista
      if (this.busqueda.pregslist) {
        var find_ = find(this.busqueda.pregslist, function (p) {
          return p.q.idquest === idq;
        });
        if (find_) this.pregform = find_;
      }
    }
  }, {
    key: "filterReqDocToWhere",
    value: function filterReqDocToWhere(rule) {
      // solo soporte preguntas
      if (this.tipo !== 'PREGUNTA') return;
      if (!rule.idquestion) return;
      this.seleccionaPreg(rule.idquestion);
      switch (this.pregform.t) {
        case 'SINO':
          this.model1 = rule.cond_bool;
          break;
        case 'TXT':
          this.model1 = rule.cond_txt;
          break;
        case 'SEL':
          this.sel = split(rule.cond_opt, ';').filter(function (s) {
            return !!s;
          });
          break;
        case 'RANGO':
          this.model1 = rule.cond_min;
          this.model2 = rule.cond_max;
          break;
        case 'PERIODO':
          this.model1 = rule.cond_ini;
          this.model2 = rule.cond_fin;
          break;
        default:
      }
    }
  }, {
    key: "condicionToFilterReqDoc",
    value: function condicionToFilterReqDoc(rule) {
      // solo soporte preguntas
      if (this.tipo !== 'PREGUNTA') return;
      if (!this.pregform) return;
      rule.idquestion = this.pregform.q.idquest;
      rule.cond_bool = null;
      rule.cond_txt = null;
      rule.cond_opt = null;
      rule.cond_min = null;
      rule.cond_max = null;
      rule.cond_ini = null;
      rule.cond_fin = null;
      switch (this.pregform.t) {
        case 'SINO':
          rule.cond_bool = this.model1;
          break;
        case 'TXT':
          rule.cond_txt = this.model1;
          break;
        case 'SEL':
          rule.cond_opt = chain(this.sel).filter(function (s) {
            return !!s;
          }).join(';').value(); // no considerar las null
          break;
        case 'RANGO':
          rule.cond_min = this.model1;
          rule.cond_max = this.model2;
          break;
        case 'PERIODO':
          rule.cond_ini = this.model1 && new Date(this.model1);
          rule.cond_fin = this.model2 && new Date(this.model2);
          break;
        default:
      }
    }
  }, {
    key: "valido",
    value: function valido() {
      switch (this.tipo) {
        case 'PREGUNTA':
          return !!this.pregform;
        case 'FECHAS':
        case 'ESTADO':
          return true;
      }
    }
  }]);
}();